<template>
	<div style="height: 25px; display: flex; justify-content: space-around;" class="totalCost">
        <div class="subtotal price">
            <span class="right" v-if=" this.cents(totalCost) == '00' && expanded" style="color: #e4d836;vertical-align: top;opacity: 0.9;font-size: 15px;margin-top: -6px;">0</span>
            <animate-number
                v-if="expanded"
                class="right"
                style="color: #e4d836;vertical-align: top;margin-left: 2px;opacity: 0.9;font-size: 15px;margin-top: -6px;"
                ref="animatedNumberTotalCents"
                :from="0" 
                mode="auto"
                :to="this.cents(totalCost) || '00'" 
                duration="700" 
                :formatter="formatter"
            ></animate-number>
            <h1  style="font-size: 23px;" class="price-tag right">
                <span class="right" v-if="this.cents(totalCost) !== '00' && this.cents(totalCost) < 10 && expanded" style="color: #e4d836;vertical-align: top;font-size: 15px;margin-top: 1px; margin-right: -2px; margin-left: 2px;">0</span>
                <animate-number
                    ref="animatedNumberTotal"
                    :from="priceFrom" 
                    mode="auto"
                    :to="totalCost" 
                    duration="700" 
                    :formatter="formatter"
                ></animate-number>
            </h1>
            <h3 style="margin-top: -5px;" class="dollar-sign">$</h3>
        </div>
    </div>
</template>

<script>
import { mapGetters }   from 'vuex';
import { EventBus }     from '../../eventBus'
import { functions }            from "../../functions.js"

export default {
    name: 'TotalCost',
    props: ["size", 'centsShow', 'expanded'],
    data() {
        return {
            priceFrom: 0,
            firstLoad: true,
            priceTo: '',
            totalCost: 0.00,
        }
    },
    watch: {
        totalCost: function (newVal){
            console.log('totalcost')
            if(this.firstLoad == true && !this.getTotalCost){
                this.priceFrom = 0
                if(this.totalcost > 0){
                    this.priceFrom = this.totalCost
                }
                this.priceTo = 0
                this.firstLoad = false
                this.updatePrice(this.priceFrom, this.priceTo)
                this.startAnimate()
                console.log('first load')
            }
            else {
                if(newVal == 0){
                    this.priceFrom = 0
                    this.priceTo = 0
                    this.updatePrice(this.priceFrom, this.priceTo)
                    this.startAnimate()
                    console.log('newval = 0')
                }
                else {
                    this.priceFrom = this.$refs.animatedNumberTotal.to
                    this.priceTo = parseFloat(newVal)
                    this.updatePrice(this.priceFrom, this.priceTo)
                    this.startAnimate()
                    console.log('updated total cost to ', this.priceTo)
                }
            }
        }
    },
    computed: 
        mapGetters([
            'getTotalCost',
        ]),
    methods: {
        cents: (num) => functions.cents(num),
        updatePrice(from, to) {
            this.$refs.animatedNumberTotal.reset(from, to)
            if(this.$refs.animatedNumberTotalCents) {
                this.$refs.animatedNumberTotalCents.reset(0, this.cents(to))
            }
        },
        startAnimate: function () {
            this.$refs.animatedNumberTotal.start()
            if(this.$refs.animatedNumberTotalCents) {
                this.$refs.animatedNumberTotalCents.start()
            }
        },
        formatter: function (num) {
            return parseInt(num)
        },
    },
    mounted(){
        EventBus.$on('totalCostChanged', (totalCost) => {
            this.totalCost = totalCost
        });
    },
    created(){
        this.totalCost = this.getTotalCost
    }
}
</script>
<style scoped>
.dollar-sign {
    float: right;
    color: #9198aa  !important;
    font-size: 15px;
}
.price-tag {
    font-size: 24px;
    font-weight: 100 !important;
    color: #e4d836!important;
    margin-top: -5px ;
    opacity: 0.9;
    margin-left: 3px;
}
.subtotal.container {
    margin-top: 90px;
}
.subtotal.label {
    color: #cfd2da !important;
    display: inline;
}

</style>